module.exports = __webpack_public_path__ + "img/1-.cd5d4b31.jpg";